import './styles.css'
import { useEffect, useState } from 'react'
import { getDescontoEmFarmacias } from '../../../services/DescontoFarmaciaService'
import { DescontoFarmacia } from '../../../interfaces/entities/DescontoFarmacia'
import LoadingApp from '../../../components/LoadingApp'
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext'
import PageTitle from '../../../components/Accessibility/PageTitle'

function DescontoEmFarmacia() {
    const [pharmacies, setPharmacies] = useState<DescontoFarmacia[]>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false)

    const accessibility = useAccessibility();


    useEffect(() => {
        const getDesconto = async () => {
            setShowLoading(true)
            const result = await getDescontoEmFarmacias();
            if(result !== null) {
                setPharmacies(result)
                setShowLoading(false)
            }
        }
        
        getDesconto();
    }, [])
    return (
        <div className="pharmacy-discount-content">
            <LoadingApp showLoading={showLoading}/>
            <div className="pharmacy-discount-header">
                <PageTitle text="Desconto em farmácia" />
                <span className="pharmacy-discount-description" style={accessibility.textStyleAccessibility}>Compre online de nossos parceiros, com desconto, e receba onde quiser. Para ter acesso aos descontos, faça o login ou cadastre-se no site das farmácias e ative o benefício <b>Unimed Campinas</b>.</span>
            </div>
            {pharmacies.map((pharmacy) => {
                return (
                    <div 
                        className="pharmacy-discount-card" 
                        tabIndex={0} 
                        style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility, cursor: 'pointer'}}
                        onClick={() => window.open(pharmacy.link, '_blank')}
                    >
                        <div className="pharmacy-discount-card-header">
                            <p className="pharmacy-discount-card-header-description" style={accessibility.textStyleAccessibility}>
                                <a 
                                    className="pharmacy-discount-card-button" 
                                    href={pharmacy.link} 
                                    target="_blank" 
                                    rel="noreferrer" 
                                    onClick={(e) => e.stopPropagation()}
                                    aria-label={`Clique aqui para comprar na ${pharmacy.descricao}`}
                                    style={accessibility.textStyleAccessibility}>
                                        Clique aqui</a> para comprar na <b>{pharmacy.descricao}</b>
                            </p>
                        </div>
                        <div className="pharmacy-discount-card-body">
                            <img src={pharmacy.imagem} alt={pharmacy.descricao} aria-label={pharmacy.descricao} />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default DescontoEmFarmacia;